import React, { useEffect } from 'react';
import { useBatteryStore } from '../store/batteryStore';
import { 
  PackViewer3D, 
  ConfigPanel, 
  ResultsTable, 
  TabPanels,
  ViewportControls
} from '../components/BatteryBuilder';

// Embeddable version of the Battery Pack Builder - optimized for iframe embedding
export default function EmbedPage() {
  const { viewMode, results, fetchCells, fetchBmsModels } = useBatteryStore();
  
  // Fetch cells and BMS on mount
  useEffect(() => {
    fetchCells();
    fetchBmsModels();
  }, [fetchCells, fetchBmsModels]);
  
  // Send message to parent window when configuration changes
  useEffect(() => {
    if (window.parent !== window) {
      window.parent.postMessage({
        type: 'BATTERY_BUILDER_RESULTS',
        data: {
          resultsCount: results.length,
          results: results.slice(0, 5) // Send top 5 results to parent
        }
      }, '*');
    }
  }, [results]);
  
  return (
    <div className="h-screen w-screen bg-zinc-950 flex flex-col overflow-hidden" data-testid="embed-page">
      {/* Compact Header */}
      <header className="h-10 border-b border-zinc-800 flex items-center justify-between px-3 bg-zinc-900/50">
        <div className="flex items-center gap-2 text-cyan-400">
          <span className="font-heading text-sm font-bold tracking-wider">
            BATTERY PACK BUILDER
          </span>
        </div>
        {results.length > 0 && (
          <div className="text-xs font-mono text-zinc-500">
            <span className="text-cyan-400">{results.length}</span> configs
          </div>
        )}
      </header>
      
      {/* Main Content */}
      <div className="flex-1 flex overflow-hidden">
        {/* Left Side - 3D Viewport */}
        <div className="flex-1 relative">
          <PackViewer3D />
          <ViewportControls />
        </div>
        
        {/* Right Side - Config & Results */}
        <div className="w-80 border-l border-zinc-800 flex flex-col">
          {/* Config Panel */}
          <div className="h-[55%] overflow-hidden">
            <ConfigPanel />
          </div>
          
          {/* Results Table */}
          <div className="flex-1 border-t border-zinc-800 overflow-hidden">
            <ResultsTable />
          </div>
        </div>
      </div>
      
      {/* Bottom Panel - Tabs (Smaller) */}
      <div className="h-56 border-t border-zinc-800">
        <TabPanels />
      </div>
    </div>
  );
}
